import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { MSProductsEntitlementsState } from 'src/interfaces/store.types';
import { useAppSelector } from 'src/store/redux';

const initialState: MSProductsEntitlementsState = {
  hasMiddleSchoolProduct: null,
};

export const msProductsEntitlementsSlice = createSlice({
  name: 'msProductsEntitlements',
  initialState,
  reducers: {
    setHasMiddleSchoolProduct: (state, action: PayloadAction<boolean>) => {
      state.hasMiddleSchoolProduct = action.payload;
    },
  },
});

export const { setHasMiddleSchoolProduct } =
  msProductsEntitlementsSlice.actions;

export const useMSProductsEntitlementsSelector = () =>
  useAppSelector(
    (state) => state.msProductsEntitlements.hasMiddleSchoolProduct,
  );

export default msProductsEntitlementsSlice.reducer;
